import { PAYMENT_PROPERTY, } from "./constants.js";
export const getContractPaymentInput = ({ provider, properties, }) => {
    return {
        provider: "custom",
        custom: {
            properties: [
                { property: PAYMENT_PROPERTY.SHARED.IDENTIFIER, value: provider },
                ...Object.entries(properties).map(([property, value]) => ({
                    property,
                    value,
                })),
            ],
        },
    };
};
